<div class="hero">
	<div class="hero-body" style="padding-bottom: 0">
		<div class="container">
			<p class="blue has-text-centered is-size-5 column is-two-thirds page-description" style="padding-bottom: 3rem">
				Tenemos la tecnología y la capacidad técnica, para atender sus necesidades en mantenimiento, reparación y caracterización de sus equipos de laboratorio e industriales.
			</p>
			<app-contact-form [isEquipmentForm]="true" buttonText="Cotizar" title="Cotiza la reparación de tu equipo"></app-contact-form>
		</div>
	</div>
</div>